export default __webpack_public_path__ + "src/assets/Pooltogether_Mobile.91c1321a7858c264a2acbe77381e5d86.svg";